import React from 'react';
import styles from './card.module.scss';

export default function Card({ children, direction = 'row', className = '' }) {
  return <div className={`${styles.card} ${styles[direction]} ${className}`}>{children}</div>;
}
